import { useEffect, useRef, useState } from 'react';
import { API } from '../service/ProductsService';

const MAX_LENGTH = 1000;   // כמו @maxLength ב-spAddFeedback

const s = {
  overlay:   { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 },
  dialog:    { width: '100%', maxWidth: 480, background: '#fff', borderRadius: 14, padding: 20, boxShadow: '0 12px 40px rgba(0,0,0,.2)' },
  header:    { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 12 },
  title:     { margin: 0, fontSize: 20, fontWeight: 700 },
  close:     { background: 'none', border: 'none', fontSize: 22, lineHeight: 1, color: '#59636e' },
  intro:     { margin: '0 0 14px', color: '#59636e', fontSize: 14 },
  label:     { display: 'block', fontSize: 13, color: '#59636e', marginBottom: 4 },
  field:     { marginBottom: 12 },
  input:     { width: '100%', padding: '9px 12px', border: '1px solid #d0d7de', borderRadius: 8, background: '#fff' },
  textarea:  { width: '100%', minHeight: 120, padding: '9px 12px', border: '1px solid #d0d7de', borderRadius: 8, resize: 'vertical' },
  counter:   { fontSize: 12, color: '#59636e', textAlign: 'left' },
  row:       { display: 'flex', gap: 10, flexWrap: 'wrap' },
  error:     { background: '#fff1f0', border: '1px solid #ffccc7', color: '#a8071a', padding: '8px 12px', borderRadius: 8, marginBottom: 12, fontSize: 14 },
  submit:    { padding: '10px 22px', fontSize: 16, fontWeight: 600, border: 'none', borderRadius: 10, background: '#1a3f9c', color: '#fff' },
  done:      { textAlign: 'center', padding: '12px 0 4px' },
  doneTitle: { fontSize: 18, fontWeight: 700, marginBottom: 6 },
  // honeypot: מוסתר במקום (לא left שלילי - בעמוד RTL זה יוצר גלילה אופקית). גולשים לא ממלאים, בוטים כן (ר' spAddFeedback)
  honeypot:  { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clipPath: 'inset(50%)', opacity: 0, pointerEvents: 'none' },
};

// חלון "שלחו לנו פידבק". onClose נקרא בסגירה (כפתור ×, Escape, לחיצה על הרקע)
const FeedbackDialog = ({ onClose }) => {
  // השם והטלפון נלקחים בשרת מהמשתמש המחובר (spAddFeedback), ולכן הטופס לא שואל עליהם
  const [form, setForm] = useState({ message: '', website: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const messageRef = useRef(null);

  useEffect(() => {
    messageRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.message.trim()) { setError('נא לכתוב את הפידבק'); return; }   // ולידציה גם ב-SP
    setSending(true);
    setError(null);
    try {
      const resp = await API.sendFeedback(form);
      const status = resp?.[0]?.[0];
      if (status?.code === 0) setSent(true);
      else setError(status?.msg || 'שגיאה בשליחה, נסו שוב');
    } catch (err) {
      setError(err.message || 'שגיאה בשליחה, נסו שוב');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={s.overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={s.dialog} role="dialog" aria-modal="true" aria-labelledby="feedback-title">
        <div style={s.header}>
          <h2 id="feedback-title" style={s.title}>שלחו לנו פידבק</h2>
          <button style={s.close} onClick={onClose} aria-label="סגירה">×</button>
        </div>

        {sent ? (
          <div style={s.done}>
            <div style={s.doneTitle}>תודה! הפידבק נשלח</div>
            <div style={s.intro}>אנחנו קוראים כל הודעה.</div>
            <button style={s.submit} onClick={onClose}>סגירה</button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p style={s.intro}>אהבתם? יש לכם רעיון איך אפשר לשפר את האתר? נשמח לשמוע.</p>

            {error && <div style={s.error}>{error}</div>}

            <div style={s.field}>
              <label style={s.label} htmlFor="fb-message">הפידבק שלכם *</label>
              <textarea
                id="fb-message"
                ref={messageRef}
                style={s.textarea}
                value={form.message}
                onChange={set('message')}
                maxLength={MAX_LENGTH}
                required
              />
              <div style={s.counter} className="num">{form.message.length}/{MAX_LENGTH}</div>
            </div>

            <div style={s.honeypot} aria-hidden="true">
              <label htmlFor="fb-website">אתר</label>
              <input id="fb-website" tabIndex={-1} autoComplete="off" value={form.website} onChange={set('website')} />
            </div>

            <button type="submit" style={s.submit} disabled={sending}>{sending ? 'שולח…' : 'שליחה'}</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackDialog;
